import type {
  BroadcastAudience,
  BroadcastCreateRequest,
  BroadcastListItem,
  BroadcastListResult,
  BroadcastPreviewResult,
} from '@ayub/shared'
import { apiGet, apiPost } from '@/lib/api'

/**
 * `apps/server/src/services/broadcast.ts`: `DEFAULT_PAGE_SIZE = 20` — broadcast tarixi
 * blogerlar/videolar ro'yxatidan ANCHA kichik (odatda oyiga bir necha o'nlab), shuning
 * uchun `BLOGGERS_PAGE_SIZE`dan (50) kichikroq qiymat serverdagi bilan mos qilib olindi.
 */
export const BROADCASTS_PAGE_SIZE = 20

export interface BroadcastListQuery {
  page?: number
  pageSize?: number
}

function buildQueryString(query: BroadcastListQuery): string {
  const params = new URLSearchParams()
  if (query.page) params.set('page', String(query.page))
  if (query.pageSize) params.set('pageSize', String(query.pageSize))
  const qs = params.toString()
  return qs.length > 0 ? `?${qs}` : ''
}

export function fetchBroadcasts(query: BroadcastListQuery): Promise<BroadcastListResult> {
  return apiGet<BroadcastListResult>(`/broadcasts${buildQueryString(query)}`)
}

/**
 * `GET /api/broadcasts/:id` — progress pollingda ishlatiladi (`hooks.ts`dagi
 * `useBroadcastProgress()`), shuning uchun `id` doim aniq (yaratilgandan keyingi javobdan
 * olingan) — mavjud bo'lmagan `id` bilan chaqirilmaydi.
 */
export function fetchBroadcast(id: number): Promise<BroadcastListItem> {
  return apiGet<BroadcastListItem>(`/broadcasts/${id}`)
}

/**
 * "Nechta odamga ketadi" — hech narsa saqlamaydi/yubormaydi (`packages/shared/src/api.ts`
 * `BroadcastPreviewResult` izohi). Auditoriya (`Kimga`) o'zgargan SAYIN qayta chaqiriladi
 * (`hooks.ts`dagi `useBroadcastPreview()`), shuning uchun bu — texnik jihatdan `GET` bo'lishi
 * kerak bo'lgan amal, lekin server kontrakti `POST` (audience tanasi murakkab bo'lgani
 * uchun — `manual` holatda 2000 tagacha ID massiv sifatida yuboriladi, URL query'ga
 * sig'maydi). Kontrakt FIKS, o'zgartirilmaydi.
 */
export function previewBroadcastAudience(
  audience: BroadcastAudience,
): Promise<BroadcastPreviewResult> {
  return apiPost<BroadcastPreviewResult>('/broadcasts/preview', { audience })
}

/**
 * Broadcast yaratadi VA yuborishni FON REJIMIDA boshlaydi — javob DARHOL qaytadi
 * (`services/broadcast.ts`: "javob DARHOL qaytadi, yuborish fon rejimida davom etadi").
 * Qaytgan `BroadcastListItem.status` shu payt odatda `'pending'` bo'ladi — haqiqiy
 * progress keyin `useBroadcastProgress()` orqali kuzatiladi.
 */
export function createBroadcast(body: BroadcastCreateRequest): Promise<BroadcastListItem> {
  return apiPost<BroadcastListItem>('/broadcasts', body)
}
